// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"bg_s"};